import { InfoCircle } from '@wfp/icons-react';
import { ModuleFooter } from '@wfp/react';
import { format } from 'date-fns';
import isEmpty from 'lodash/isEmpty';
import type { FC } from 'react';
import React from 'react';

interface IRefreshInfo {
  date: string;
  type: string;
  user: string;
}

interface Props {
  refreshInfo: IRefreshInfo[];
}

const LatestRefreshInfo: FC<Props> = ({ refreshInfo = [] }) => {
  if (isEmpty(refreshInfo)) return <></>;

  const flatRefreshInfoList = refreshInfo.flat();

  const indexOfMaxValue = flatRefreshInfoList?.reduce(
    (iMax, x, i, arr) =>
      new Date(x.date) > new Date(arr[iMax].date) ? i : iMax,
    0,
  );

  const latestRefreshInfo = flatRefreshInfoList?.[indexOfMaxValue];
  const formattedDate = `${format(
    new Date(latestRefreshInfo.date),
    "do MMMM yyyy 'at' hh:mm:ss a",
  )}`;

  return (
    <ModuleFooter>
      <div className="latest-refresh-info-wrapper">
        <InfoCircle
          color="grey"
          className="last-refresh-date-icon"
          data-test-id="latest-refresh-date"
        />
        <div className="latest-refresh-info-text">
          Data refreshed on&nbsp;
          <span title="Central European Time">
            {`${formattedDate} (CET)`}
          </span>{' '}
          {latestRefreshInfo?.type === 'automatic'
            ? '(automated)'
            : `by ${latestRefreshInfo?.user}`}
        </div>
      </div>
    </ModuleFooter>
  );
};

export default LatestRefreshInfo;
